import useCentralizedChatManager from '../../components/useCentralizedChatManager'
import LegacyChatbox from '../Chatbox/LegacyChatbox'

export default function CommunityChatbox({
    userUrn,
    groupUrn,
    isEmpty = false,
    EmptyMessagesComponent,

    onSendMessage = null,
}: {
    userUrn: string
    groupUrn: string
    isEmpty?: boolean
    EmptyMessagesComponent?: JSX.Element

    onSendMessage?: ((message: string) => void) | null
}) {
    const chatManager = useCentralizedChatManager({
        userUrn,
        roomUrn: groupUrn,
        roomType: 'community-message-group',
        isEnabled: true,
        isEmpty: isEmpty,
    })

    return (
        <LegacyChatbox
            chatManager={chatManager}
            enableFiles={false}
            onSendMessage={onSendMessage}
            EmptyMessagesComponent={EmptyMessagesComponent}
        />
    )
}
